import SpareFoot from '@/components/HomebuyerOffers/SpareFoot.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/offers/SpareFoot',
  name: RouteNames.SpareFoot,
  component: SpareFoot,
};

export default route;
